import React from 'react';
import { number, shape, node, bool } from 'prop-types';
import { getDaysPassedBetweenDates, getHumanisedTextFromNumberOfDays } from '@paddl/utils-js';
import { ActivityProgress } from '../../../../../..';
import { ProgressWrapper, ProgressStatus, ProgressStatusWrapper } from '../../../../../Activity.styles';
const newDate = new Date();
const day = newDate.getDate();
const month = newDate.getMonth() + 1;
const year = newDate.getFullYear();
export const OneLineSmallProgress = _ref => {
  let {
    progressIndicatorStyles: {
      progressIndicatorColor,
      progressIndicatorCircleColor,
      icon,
      status
    },
    progress,
    duration: {
      startDate,
      endDate,
      isCurrent
    } = {},
    editButton
  } = _ref;
  const activityLength = getHumanisedTextFromNumberOfDays(getDaysPassedBetweenDates({
    startDate: new Date(startDate.year, startDate.month, startDate.day),
    endDate: isCurrent ? new Date(year, month, day) : new Date(endDate.year, endDate.month, endDate.day)
  }));
  return /*#__PURE__*/React.createElement(ProgressWrapper, null, editButton && editButton, /*#__PURE__*/React.createElement("div", {
    className: "content-wrapper"
  }, /*#__PURE__*/React.createElement(ActivityProgress, {
    size: "small",
    progress: progress,
    progressIndicatorColor: progressIndicatorColor,
    progressIndicatorCircleColor: progressIndicatorCircleColor,
    icon: icon
  }), /*#__PURE__*/React.createElement(ProgressStatusWrapper, {
    size: "small"
  }, /*#__PURE__*/React.createElement(ProgressStatus, {
    color: progressIndicatorColor,
    size: "small",
    className: "progress-status",
    "data-test-id": "progress-status"
  }, status === 'Incomplete' ? "".concat(progress, "% Complete") : activityLength))));
};
OneLineSmallProgress.propTypes = {
  progressIndicatorStyles: shape({}).isRequired,
  progress: number.isRequired,
  duration: shape({
    startDate: shape({
      day: number,
      month: number,
      year: number
    }),
    endDate: shape({
      day: number,
      month: number,
      year: number
    }),
    isCurrent: bool
  }).isRequired,
  editButton: node
};
OneLineSmallProgress.defaultProps = {
  editButton: undefined
};